import {
  LkTopic as Data,
  LkTopicCollection as Collection,
} from '@/typings/api/Topic'
import {
  BaseApiParams,
  BaseApiResponse,
  BaseApiResponseCollection,
} from '@/typings/common'

import { BaseLkApiAuth } from '@/api/BaseApiAuth'
import { AxiosRequestConfig } from 'axios'


type BRC = BaseApiResponseCollection<never> & {
  topics: Collection[];
}

export class LkTopicsApi extends BaseLkApiAuth<
  Data,
  Collection,
  BaseApiParams,
  BaseApiResponse<Data>,
  BRC
  > {
  protected readonly endpoint = 'topics';

  public getAll<P extends BaseApiParams, R extends BRC = BRC>(
    rawParams: P, config?: AxiosRequestConfig,
  ) {
    const path = '/tree'
    const [url, params] = this.getUrl(path, rawParams)
    return this.request<never, R>('GET', url, { params, ...config })
  }
}
